export const validationApiKey = (name: string) => {
  return name === '' || /^[\w ~`!@#$%^&*()\-_=+{}[\]|/:;"'<>,.?]{0,100}$/.test(name);
};
